export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/notepad.65dc25ce.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};